import {Component, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {CallEvent, CallEventState} from "../../../../units/models/call-event";
import {unitDashboardCallEventAnimations} from "../../../../units/animations/unit-dashboard-call-event-animations";
import {DxTooltipComponent} from "devextreme-angular";

@Component({
  selector: 'app-call-event',
  templateUrl: './call-event.component.html',
  styleUrl: './call-event.component.scss',
  animations: unitDashboardCallEventAnimations
})
export class CallEventComponent implements OnDestroy {

    @Input() set expandedEventId(value: string | null) {
        if (this._expandedEventId !== value) {
            this.imageTooltip?.instance?.hide();
        }
        this._expandedEventId = value;
    }
    get expandedEventId(): string | null { return this._expandedEventId; }
    private _expandedEventId: string | null = null;
    @Input() event: CallEvent | null = null;

    @Output() callEventClicked: EventEmitter<string> = new EventEmitter();

    @ViewChild('imageTooltip') imageTooltip!: DxTooltipComponent;

    hoveredImageUrl: string | null = null;

    protected readonly CallEventState = CallEventState;

    readonly stateTooltipKeys: Record<string, string> = {
        [CallEventState.MISSED]: 'Dashboard.MissedCallEvent',
        [CallEventState.STARTED]: 'Dashboard.ProgressCallEvent',
        [CallEventState.ANSWERED]: 'Dashboard.AnsweredCallEvent',
        [CallEventState.CANCELLED]: 'Dashboard.CancelledCallEvent',
        [CallEventState.REJECTED]: 'Dashboard.RefusedCallEvent',
        [CallEventState.FORWARDED]: 'Dashboard.ForwardedCallEvent',
        [CallEventState.BRIDGED]: 'Dashboard.BridgedCallEvent',
    };

    readonly timePeriodKeys: Record<string, string> = {
        morning: 'Dashboard.TimePeriodMorning',
        afternoon: 'Dashboard.TimePeriodAfternoon',
        evening: 'Dashboard.TimePeriodEvening'
    };

    private hideTimer: any;

    getTimePeriod(timestamp: number): string {
        const hour = new Date(timestamp * 1000).getHours();
        if (hour >= 6 && hour < 12) return 'morning';
        if (hour >= 12 && hour < 18) return 'afternoon';
        return 'evening';
    }

    onImageHover(event: MouseEvent, imageUrl: string) {
        clearTimeout(this.hideTimer);
        this.hoveredImageUrl = imageUrl;
        const target = event.currentTarget as HTMLElement;
        const instance = this.imageTooltip?.instance;
        if (instance) {
            instance.option('target', target);
            instance.show(target);
        }
    }

    onImageLeave() {
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
            this.imageTooltip?.instance?.hide();
        }, 120);
    }

    ngOnDestroy() {
        clearTimeout(this.hideTimer);
    }
}
